export const trackShowModalCategory = 'Booking - Modal';
export const trackBookOutOfNetwork = 'Book Out of Network Doctor Anyway';
export const trackSkippedOutOfNetwork =
    'Reschedule skipped initial out of network warning';
export const trackClickedCloseModal = 'Click Close Modal';
export const trackClickedFindDoctorButton =
    'Click Modal Search Link For Procedure';
